
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexAnswer, IFlexMessageBubble, IFlexMessageCarousel } from '@/utils/types'
import PreviewPanel from '@/components/common/flex-message/PreviewPanel.vue'
import TreePanel from '@/components/common/flex-message/TreePanel.vue'
import FormPanel from '@/components/common/flex-message/FormPanel.vue'
import cloneDeep from 'lodash/cloneDeep'
import { UserModel } from '@/models/user-model'

@Options({
  components: { FormPanel, TreePanel, PreviewPanel },
  directives: { maska },
  emits: ['update:data'],
})
export default class FlexMessageModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  flexAnwser!: IFlexAnswer

  hoverPath = ''
  selectedPath = ''
  nodePath = []
  errorPath: string[] = []

  form: IFlexAnswer = {}

  get userInfo(): UserModel {
    return this.$store.getters.userInfo
  }

  onInitMessage(message: IFlexMessageBubble | IFlexMessageCarousel) {
    this.errorPath = []
    if (this.userInfo.canWriteApp) {
      this.$nextTick(() => {
        this.$refs.treePanel.initMessage(message)
      })
    }
  }

  onSelectNode(path, nodePath) {
    this.selectedPath = path
    this.nodePath = nodePath
  }

  onSelectNodeFromPreview(path, node, nodePath) {
    if (this.errorPath.length === 0) {
      this.onSelectNode(path, nodePath)
      if (this.userInfo.canWriteApp) {
        this.$nextTick(() => {
          this.$refs.treePanel.onSelectNode(node, path)
        })
      }
    }
  }

  onHoverNode(path) {
    this.hoverPath = path
  }

  onValidate(val) {
    const index = this.errorPath.indexOf(this.selectedPath)

    if (!val) {
      if (index === -1) {
        this.errorPath.push(this.selectedPath)
      }
    } else {
      if (index !== -1) {
        this.errorPath.splice(index, 1)
      }
    }
  }

  async onSubmit() {
    if (this.errorPath.length === 0 && this.form.altText !== '') {
      this.$emit('update:data', this.form)
      this.visible = false
    }
    if (this.form.altText === '') {
      this.$q.notify({
        type: 'negative',
        message: this.$t('validate.this_field_is_required', {
          placeholder: this.$t('label.common.answer.alt_text'),
        }),
      })
    }
  }

  updateAltText(val) {
    if (!this.form.altText) {
      this.form.altText = val
    }
  }

  mounted() {
    this.form = { ...this.form, ...cloneDeep(this.flexAnwser) }
    // eslint-disable-next-line
    this.parentForm = this.form as any
    this.initForm = cloneDeep(this.parentForm)
  }
}
